/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_Hydraulic_ChangeoverInputs */



/**
* | output |
* | --- |
* | "Changeover" |
*
* @param {Actuator_Type_Hydraulic_ChangeoverInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_hydraulic_changeover = /** @type {((inputs?: Actuator_Type_Hydraulic_ChangeoverInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_Hydraulic_ChangeoverInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Changeover")
	return /** @type {LocalizedString} */ ("Change Over")
});